module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/plugin-gotenehus-regions/plugin-gotenehus-regions.component.scss
// module id = ./src/app/pages/plugin-gotenehus-regions/plugin-gotenehus-regions.component.scss
// module chunks = main